<template>
  <div :key="insuranceKey" class="row" name="insurance-component">
    <h5 class="text-center">{{computeCaption(fields_en['please_provide_payment_information'], $store.state.lang.value.toLowerCase())}}</h5>
    <div :class="[generalClass, validatedSectionClass]">
    <div v-if="$store.state.configs.RESTRICT_INSURANCE_BY_ICD === true && this.$store.state.icdCodes.length === 0" class="row">
            <h5 id="icd codes" class="primary-color text-center">
              {{computeCaption(fields_en['icd_codes_disclaimer'], $store.state.lang.value.toLowerCase())}}
            </h5>
    </div>
    <div class="row">
      <div class="col-sm-3 col-md-offset-1">
        <div class="form-group mb-0">
          <label id="select-payment">
            {{computeCaption(fields_en['select_payment_type'], $store.state.lang.value.toLowerCase())}}
          </label>
        </div>
      </div>

      <div class="col-sm-7">
        <div class="form-group gender-float">
            <el-radio-group @change="switchInsuranceCash" v-model="model.selectedBill" size="small">
              <el-radio-button tabindex="0"
                              v-for="(item, index) in allBills"
                              :key="allBills[index][0]"
                              value="true" inline
                              :label="allBills[index][0]">{{ computeCaption(allBills[index][0], $store.state.lang.value.toLowerCase()) }}</el-radio-button>
            </el-radio-group>
        </div>
      </div>
    </div>
      <!-- Disclaimer Payment -->
      <ConsentDisclaimer
        :submit="submit"
        :inline_disclaimer_and_consent="false"
        :allow_separate_signature="false"
        :allow_consent="false"
        :allow_disclaimer="allowDisclaimer"
        :allow_text_name_disclaimer="false"
        :disclaimer_name_text="disclaimerNameText"
        :allow_signature_disclaimer="allowSignatureDisclaimer"
        :disclaimer_en="disclaimer"
        :disclaimer_es="disclaimer"
        :disclaimer_zh="disclaimer"
        :partOfSection ="true"
        @validateSignature="validateSignature"
        ref="ConsentDisclaimer" />
      <!--Questions-->
      <QuestionsSection ref="questions" :section="model.selectedBill"></QuestionsSection>
<!--        Primary Insurance-->
    <div v-if="this.model.insurance_pay === 'insurance'" class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <small>{{computeCaption(fields_en['if_your_insurance_is_not_available_in_the_list_please_select_other'], $store.state.lang.value.toLowerCase())}}
          </small>
        </div>
      </div>
    </div>
    <div v-if="this.model.insurance_pay === 'insurance' && this.$store.state.dependentSelected" class="row">
      <div class="col-md-10 col-md-offset-1">
         <el-checkbox v-model="checked">{{computeCaption(fields_en['same_insurance_as_main_user'], $store.state.lang.value.toLowerCase())}}</el-checkbox>
        </div>
    </div>
    <form @submit.prevent="triggerNextTab">
      <div v-if="this.model.insurance_pay === 'insurance'" class="row">
        <!-- Relationship -->
        <!--Relationship to Patient:-->
        <div class="col-md-5 col-md-offset-1 form-group">
          <label class="control-label required">
            {{computeCaption(fields_en['patient_relationship_to_insured'], $store.state.lang.value.toLowerCase())}}
          </label
          ><br />
          <el-select
            size="large"
            data-vv-as="Relationship"
            v-validate="modelValidations.relationship"
            placeholder="Single Select"
            name="relationship"
            v-model="model.relationship"
          >
            <el-option
              v-for="option in relationshipList"
              class="select-danger"
              :value="option.value"
              :label="computeCaption(option.value, $store.state.lang.value.toLowerCase())"
              :key="option.label"
            >
            </el-option>
          </el-select>
          <small class="text-danger" v-show="relationship.invalid">
            {{getError("relationship") && computeCaption(getError("relationship"), $store.state.lang.value.toLowerCase())}}
          </small>
        </div>
        <div class="col-md-5 ">
          <div class="form-group">
            <label class="control-label required">
              {{computeCaption(fields_en['primary_insurance_name'], $store.state.lang.value.toLowerCase())}}
            </label>
            <el-select :disabled="(this.model.insurance_pay === 'uninsured' || this.model.insurance_pay === 'cash') || (this.model.insurance_pay === 'insurance' && checked === true)"
                       filterable
                       type="text"
                       size="large"
                       popper-class="select-small-options"
                       data-vv-as="Primary Insurance Name"
                       v-validate="modelValidations.primary_insurance"
                       name="primary_insurance"
                       placeholder="ex: Aetna"
                       v-model="model.primary_insurance">
              <el-option v-for="option in this.$store.state.insurance"
                         class="select-danger"
                         :value="option.name"
                         :label="option.name"
                         :key="option.name">
              </el-option>
            </el-select>
            <div class="default-grey font-small" v-show="getFieldDescription('insurance_name')" v-html="getFieldDescription('insurance_name') || ''"></div>
            <small class="text-danger" v-show="primary_insurance.invalid">
              {{getError("primary_insurance") && computeCaption(getError("primary_insurance"), $store.state.lang.value.toLowerCase())}}
            </small>
          </div>
        </div>
    </div>

      <div v-if="this.model.insurance_pay === 'insurance'" class="row">
            <!-- Insurance Name Input -->
         <div class="col-md-10 col-md-offset-1" v-if="this.model.primary_insurance === 'Other'">
          <div class="form-group">
            <label class="control-label required">
              {{computeCaption(fields_en['primary_insurance_name_input'], $store.state.lang.value.toLowerCase())}}
            </label>
            <input class="form-control"  :disabled="(this.model.insurance_pay === 'uninsured' || this.model.insurance_pay === 'cash') || (this.model.insurance_pay === 'insurance' && checked === true)"
                  type="text"
                  data-vv-as="Primary Insurance Name"
                  name="primary_insurance_name_input"
                  v-validate="modelValidations.primary_insurance_name_input"
                  v-model="model.primary_insurance_name_input"
                  placeholder='ex: Hospital'
            />
            <small class="text-danger" v-show="primary_insurance_name_input.invalid">
              {{getError("primary_insurance_name_input") && computeCaption(getError("primary_insurance_name_input"), $store.state.lang.value.toLowerCase())}}
            </small>
          </div>
        </div>
       <!--policy number-->
        <div class="col-md-5 col-md-offset-1">
          <div class="form-group">
            <label class="control-label required">
              {{computeCaption(fields_en['policy_number'], $store.state.lang.value.toLowerCase())}}
            </label>
            <input class="form-control"  :disabled="(this.model.insurance_pay === 'uninsured' || this.model.insurance_pay === 'cash') || (this.model.insurance_pay === 'insurance' && checked === true)"
                  type="text"
                  data-vv-as="Policy Number"
                  name="policy_number"
                  v-validate="modelValidations.policy_number"
                  v-model="model.policy_number"
                  placeholder='ex: 123456789'
            />
            <div class="default-grey font-small" v-show="getFieldDescription('policy_number')" v-html="getFieldDescription('policy_number') || ''"></div>
            <small class="text-danger" v-show="policy_number.invalid">
              {{getError("policy_number") && computeCaption(getError("policy_number"), $store.state.lang.value.toLowerCase())}}
            </small>
          </div>
        </div>
      <!--Group Number -->
        <div class="col-md-5 ">
          <div class="form-group">
            <label class="control-label">
              {{computeCaption(fields_en['group_number'], $store.state.lang.value.toLowerCase())}}
            </label>
            <input class="form-control" :disabled="(this.model.insurance_pay === 'uninsured' || this.model.insurance_pay === 'cash') || (this.model.insurance_pay === 'insurance' && checked === true)"
                  type="text"
                  data-vv-as="Group Number"
                  name="group_number"
                  v-validate="modelValidations.group_number"
                  v-model="model.group_number"
                  placeholder="ex: 123456789"
            />
            <div class="default-grey font-small" v-show="getFieldDescription('group_number')" v-html="getFieldDescription('group_number') || ''"></div>
            <small class="text-danger" v-show="group_number.invalid">
              {{getError("group_number") && computeCaption(getError("group_number"), $store.state.lang.value.toLowerCase())}}
            </small>
          </div>
        </div>
      </div>
      <input type="submit" value="Submit" hidden>
    </form>

    <div class="row" v-if="this.model.insurance_pay === 'insurance'" v-show="!(this.model.relationship === 'Self' && this.hide_self_completed_fields)">
    <div class="col-md-10 col-md-offset-1">
      <el-row :gutter="15">
        <el-col :span="checkMediaScreenWidth() ? 24 : (this.$store.state.requirements['insured_middle_name'] ? 8 : 12)">
          <label class="required">
            {{computeCaption(fields_en['insured_first_name'], $store.state.lang.value.toLowerCase())}}
            </label><br>
          <el-input id="firstName"
                    size="small"
                    name="insured_first_name"
                    data-vv-as="Insured First Name"
                    v-validate="modelValidations.insured_first_name"
                    v-model="model.insured_first_name"
                    :disabled="(this.model.insurance_pay === 'uninsured' || this.model.insurance_pay === 'cash') || (this.model.insurance_pay === 'insurance' && $store.state.requirements.first_name && (this.model.relationship === 'Self' || checked === true))">
          </el-input>
           <div class="default-grey font-small" v-show="getFieldDescription('insured_first_name')" v-html="getFieldDescription('insured_first_name') || ''"></div>
          <small class="text-danger" v-show="insured_first_name.invalid">
            {{getError("insured_first_name") && computeCaption(getError("insured_first_name"), $store.state.lang.value.toLowerCase())}}
          </small>
        </el-col>

        <el-col :span="checkMediaScreenWidth() ? 24 : 8" v-if="this.$store.state.requirements['insured_middle_name']">
          <label :class="checkRequirement('insured_middle_name') ? 'required' : ''">
            {{computeCaption(fields_en['insured_middle_name'], $store.state.lang.value.toLowerCase())}}
            </label><br>
          <el-input id="middleName"
                    size="small"
                    data-vv-as="Insured Middle Name"
                    name="insured_middle_name"
                    v-validate="modelValidations.insured_middle_name"
                    v-model="model.insured_middle_name"
                    :disabled="(this.model.insurance_pay === 'uninsured' || this.model.insurance_pay === 'cash') || (this.model.insurance_pay === 'insurance' && (this.model.relationship === 'Self' || checked === true) && !!$store.state.requirements.middle_name)">
          </el-input>
          <div class="default-grey font-small" v-show="getFieldDescription('insured_middle_name')" v-html="getFieldDescription('insured_middle_name') || ''"></div>
          <small class="text-danger" v-show="insured_middle_name.invalid">
            {{computeCaption(getError("insured_middle_name"), $store.state.lang.value.toLowerCase())}}
          </small>
        </el-col>

        <el-col :span="checkMediaScreenWidth() ? 24 : (this.$store.state.requirements['insured_middle_name'] ? 8 : 12)">
          <label class="required">
            {{computeCaption(fields_en['insured_last_name'], $store.state.lang.value.toLowerCase())}}</label><br>
          <el-input id="lastName"
                    size="small"
                    name="insured_last_name"
                    data-vv-as="Insured Last Name"
                    v-validate="modelValidations.insured_last_name"
                    v-model="model.insured_last_name"
                    :disabled="(this.model.insurance_pay === 'uninsured' || this.model.insurance_pay === 'cash') || (this.model.insurance_pay === 'insurance' && $store.state.requirements.last_name && (this.model.relationship === 'Self' || checked === true ))"
                    >
          </el-input>
          <div class="default-grey font-small" v-show="getFieldDescription('insured_last_name')" v-html="getFieldDescription('insured_last_name') || ''"></div>
          <small class="text-danger" v-show="insured_last_name.invalid">
            {{getError("insured_last_name") && computeCaption(getError("insured_last_name"), $store.state.lang.value.toLowerCase())}}
          </small>
        </el-col>
      </el-row>
    </div>
  </div>
  <br>

    <div v-if="this.model.insurance_pay === 'insurance'" v-show="!(this.model.relationship === 'Self' && this.hide_self_completed_fields)" class="row">
      <!--insured date of birth-->
      <div class="col-md-5 col-md-offset-1">
        <div class="form-group">
          <label class="control-label required">
            {{computeCaption(fields_en['insured_date_of_birth'], $store.state.lang.value.toLowerCase())}}
          </label>
          <input class="form-control date-insured-cleave-format"
                :disabled="(this.model.insurance_pay === 'uninsured' || this.model.insurance_pay === 'cash') || (this.model.insurance_pay === 'insurance'  && $store.state.requirements.date_of_birth && (this.model.relationship === 'Self' || checked === true))"
                type="text"
                data-vv-as="Insured Date of Birth"
                name="insured_date_of_birth_pretty"
                v-validate="modelValidations.insured_date_of_birth_pretty"
                v-model="model.insured_date_of_birth_pretty"
                v-on:keyup.backspace="cleaveBackspaceFix($event.target)"
                @change="validateDate($event.target.value)"
                placeholder="ex: 12/22/1980"
                maxlength="10"
          />
          <div class="default-grey font-small" v-show="getFieldDescription('insured_date_of_birth')" v-html="getFieldDescription('insured_date_of_birth') || ''"></div>
          <small class="text-danger" v-if="errorDate">
            {{errorDate && computeCaption(errorDate, $store.state.lang.value.toLowerCase())}}
          </small>
        </div>
      </div>

      <!-- insured gender -->
      <div class="col-md-5">
        <div class="form-group">
          <label class="control-label" :class="checkRequirement('gender') ? 'required' : ''">
            {{computeCaption(fields_en['insured_gender'], $store.state.lang.value.toLowerCase())}}
          </label>
          <el-select size="large" :disabled="(this.model.insurance_pay === 'uninsured' || this.model.insurance_pay === 'cash') || (this.model.insurance_pay === 'insurance' && $store.state.requirements.gender !== '' && (this.model.relationship === 'Self' || checked === true))"
                     data-vv-as="Insured Gender"
                     v-validate="modelValidations.insured_gender"
                     placeholder="Single Select"
                     name="insured_gender"
                     v-model="model.insured_gender">
              <el-option v-for="option in $store.state.gender"
                         class="select-danger"
                         :value="option.name"
                         :label="computeCaption(option.name, $store.state.lang.value.toLowerCase())"
                         :key="option.name">
              </el-option>
          </el-select>
          <div class="default-grey font-small" v-show="getFieldDescription('insured_gender')" v-html="getFieldDescription('insured_gender') || ''"></div>
          <small class="text-danger" v-show="insured_gender.invalid">
            {{getError("insured_gender") && computeCaption(getError("insured_gender"), $store.state.lang.value.toLowerCase())}}
          </small>
        </div>
      </div>
    </div>

    <div v-if="this.model.insurance_pay === 'insurance' && this.$store.state.requirements.insured_address" v-show="!(this.model.relationship === 'Self' && this.hide_self_completed_fields)" class="row">
      <div class="col-md-10 col-md-offset-1">
        <Address id="insurance"
                :isDisabled="$store.state.requirements.address && (model.relationship === 'Self' || checked === true)"
                :key="insuredAddress"
                @updateAddress="updateAddress"
                 @updateAddress2="updateAddress2"
                 :same_address2="this.model.insured_address2"
                :componentsInsurance="model.insured_address_components"
                 :checkRequired="this.checkRequirement('insured_address')"
                wizardStep="insurance"
        ref="AddressComponent"/>
        <small class="text-danger" v-if="address_error">
          {{address_error && computeCaption(address_error, $store.state.lang.value.toLowerCase())}}
        </small>
      </div>
    </div>

    <div v-if="this.model.insurance_pay === 'insurance' && this.$store.state.required_insurance_ssn" class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <label class="control-label" :class="{required: this.$store.state.required_insurance_ssn}">
            {{computeCaption(fields_en['social_security_number'], $store.state.lang.value.toLowerCase())}}
          </label>
          <input class="form-control ssn-cleave-format1"
                  autocomplete="off"
                  type="text"
                  data-vv-as="Social Security Number"
                  name="social_security_number"
                  v-validate="modelValidations.social_security_number"
                  v-on:keyup.backspace="cleaveBackspaceFix($event.target)"
                  v-model="model.social_security_number"
          />
          <div class="default-grey font-small" v-show="getFieldDescription('social_number')" v-html="getFieldDescription('social_number') || ''"></div>
          <small class="text-danger" v-show="social_security_number.invalid">
            {{getError("social_security_number") && computeCaption(getError("social_security_number"), $store.state.lang.value.toLowerCase())}}
          </small>
        </div>
      </div>
    </div>

    <div v-if="this.model.insurance_pay === 'insurance' && allow_insurance_card" class="row text-center">
        <h5 v-html="computeCaption(fields_en['upload_insurance_card'], $store.state.lang.value.toLowerCase())">
        </h5>
        <MultipleInput :caption="computeReportableCaption($store.state.requirements['insurance_card_image']['reportable_name'], fields_en['insurance_card'], $store.state.lang.value.toLowerCase())" :partOfSection="true" :allow="allow_insurance_card" :required="required_insurance_card" ref="insuranceCard" @isValidMultipleInput="isValidMultipleInput"></MultipleInput>
    </div><br>

    <div v-if="this.model.insurance_pay === 'insurance'">
      <small class="text-danger"> {{errorMessage}} </small>
    </div>

    <div v-if="this.model.insurance_pay == 'uninsured' && allow_dl_or_ssn" class="row">
      <!-- Driver license number  -->
      <div class="col-md-4 col-md-offset-1">
        <div class="form-group">
          <label class="control-label">
            {{computeCaption(fields_en['driver_license_number'], $store.state.lang.value.toLowerCase())}}
          </label>
          <input class="form-control"
                 type="text"
                 data-vv-as="Driver License Number"
                 name="driver_license_number"
                 v-validate="modelValidations.driver_license_number"
                 v-model="model.driver_license_number"
          />
          <div class="default-grey font-small" v-show="getFieldDescription('driver_license_number')" v-html="getFieldDescription('driver_license_number') || ''"></div>
        </div>
      </div>

      <div class="col-md-1 mb-10">
        <small class="border-none">{{computeCaption(fields_en['or'], $store.state.lang.value.toLowerCase())}}</small>
      </div>

      <div class="col-md-5">
        <div class="form-group">
          <label class="control-label" :class="{required: this.$store.state.required_uninsured_ssn}">
            {{computeCaption(fields_en['social_security_number'], $store.state.lang.value.toLowerCase())}}
          </label>
          <input class="form-control ssn-cleave-format1"
                 autocomplete="off"
                 type="text"
                 data-vv-as="Social Security Number"
                 name="social_security_number"
                 v-validate="modelValidations.social_security_number"
                 v-on:keyup.backspace="cleaveBackspaceFix($event.target)"
                 v-model="model.social_security_number"
          />
          <div class="default-grey font-small" v-show="getFieldDescription('social_number')" v-html="getFieldDescription('social_number') || ''"></div>
          <small class="text-danger" v-show="social_security_number.invalid">
            {{getError("social_security_number") && computeCaption(getError("social_security_number"), $store.state.lang.value.toLowerCase())}}
          </small>
        </div>
      </div>

      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <input class="form-control display-none"
                 type="text"
                 data-vv-as="Social Number"
                 name="error_uninsured"
                 v-validate="modelValidations.error_uninsured"
                 v-model="model.error_uninsured"
                 placeholder="ex: John Smith"
          />
          <small class="text-danger" v-show="error_uninsured.invalid">
            {{getError("error_uninsured") && computeCaption(getError("error_uninsured"), $store.state.lang.value.toLowerCase())}}
          </small>
        </div>
      </div>
    </div>
      <div class="row" v-show="this.model.insurance_pay !== 'insurance'">
        <div class="col-md-10 col-md-offset-1">
          <div class="form-group">
            <label class="control-label" for="note">
              {{computeCaption(fields_en['note'], $store.state.lang.value.toLowerCase())}}
            </label>
            <div class="custom-file">
              <el-input id="note" type="textarea" v-model="model.note"></el-input>
            </div>
          </div>
        </div>
      </div>
    <div v-if="allow_payment && this.model.insurance_pay == 'cash'" class="row">
        <div class="col-sm-3 col-md-offset-1">
          <div class="form-group mb-0">
            <label id="select-payment">{{computeCaption(fields_en["select_payment_method"], $store.state.lang.value.toLowerCase())}}</label>
          </div>
        </div>

        <div class="col-sm-7">
          <div class="form-group">
              <el-radio-group @change="switchCashPayment" v-model="paymentMethod" size="small">
                  <el-radio-button value="true" inline label="card" :class="hide_pay_with_card ? 'display-none' : ''">{{computeCaption(fields_en['pay_with_card'], $store.state.lang.value.toLowerCase())}}</el-radio-button>
                  <el-radio-button inline label="site" :class="hide_pay_at_collection ? 'display-none' : ''">{{computeCaption(fields_en['pay_at_collection'], $store.state.lang.value.toLowerCase())}}</el-radio-button>
                </el-radio-group>
          </div>
        </div>
      </div>

      <div v-if="allow_payment && paymentMethod === 'card' && this.model.insurance_pay == 'cash'" class="row">
        <div class="col-md-10 col-md-offset-1">
          <h5 class="text-center">
            {{computeCaption(fields_en['after_registration_you_will_be_redirected_to_a_payment_page'], $store.state.lang.value.toLowerCase())}}
          </h5>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import Cleave from 'cleave.js'
  import {Row, Col, Autocomplete, Input, Drawer, Button, RadioGroup, Radio, RadioButton, DatePicker, Checkbox} from 'element-ui'
  import {FormatterUtils} from '../../../../../utils/Formatter.js'
  import {ValidationUtils} from '../../../../../utils/Validation.js'
  import Address from './Address'
  import RecursiveQuestions from './RecursiveQuestions'
  import MedicationData from './MedDataRegistration'
  import MultipleInput from '../../Utils/MultipleInput.vue'
  import ConsentDisclaimer from '../../Utils/ConsentDisclaimer'
  import {TranslationsUtils} from '../../../../../utils/Translations'
  import {AccessionUtils} from '../../../../../utils/AccessionDetailsProcessing'
  import {QuestionUtils} from '../../../../../utils/Questions'
  import QuestionsSection from '../../Utils/QuestionsSection'
  import {SettingsUtils} from '../../../../../utils/SiteConfigurations'
  import {LayoutCalculationUtils} from '../../../../../utils/LayoutCalculation'
  import _ from 'lodash'
  import axios from 'axios'
  import {PatientInfoUtils} from '../../../../../utils/PatientInfo'

  require('cleave.js/dist/addons/cleave-phone.us')
  export default {
    components: {
      [Input.name]: Input,
      [DatePicker.name]: DatePicker,
      [Autocomplete.name]: Autocomplete,
      [Drawer.name]: Drawer,
      [Button.name]: Button,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [RadioButton.name]: RadioButton,
      [Checkbox.name]: Checkbox,
      Address,
      'recursive-question': RecursiveQuestions,
      MedicationData,
      MultipleInput,
      ConsentDisclaimer,
      QuestionsSection,
      [Row.name]: Row,
      [Col.name]: Col
    },
    mixins: [FormatterUtils, ValidationUtils, TranslationsUtils, AccessionUtils, QuestionUtils, SettingsUtils, LayoutCalculationUtils, PatientInfoUtils],
    data () {
      return {
        errorMessage: '',
        submit: false,
        insuranceKey: 0,
        allBills: [],
        checked: '',
        disclaimerNameText: this.$store.state.configs['GOPASS_DISCLAIMER_NAME_TEXT'],
        disclaimer: '',
        allowDisclaimer: false,
        allowSignatureDisclaimer: false,
        insuredAddress: 1,
        address_error: '',
        dummyArray: [{name: 'self'}, {name: 'Tom Willis'}, {name: 'Obama'}, {name: 'Jimmy'}],
        suggestions: [],
        answers_es: {},
        answers_zh: {},
        requirements: [],
        questionError: '',
        errorDate: '',
        client_bill_translation: '',
        paymentMethod: '',
        questionErrorDate: [],
        answer_no: 'No',
        amount: this.$store.state.configs.PAYMENT_AMOUNT,
        allow_payment: this.isTrue(this.$store.state.configs.ALLOW_PAYMENT),
        allow_insurance_card: this.isTrue(this.$store.state.configs.ALLOW_INSURANCE_CARD),
        required_insurance_card: this.isTrue(this.$store.state.configs.REQUIRED_INSURANCE_CARD),
        allow_above_medication_text: this.$store.state.configs.ALLOW_ABOVE_MEDICATION_TEXT,
        force_valid_address: this.isTrue(this.$store.state.configs.FORCE_VALID_ADDRESS),
        fields_en: {
          or: 'OR',
          pay_with_card: 'Pay with card',
          pay_at_collection: 'Pay at collection',
          select_payment_method: 'Select Payment Method',
          same_insurance_as_main_user: 'Same insurance as main user',
          icd_codes_disclaimer: this.$store.state.configs.RESTRICT_INSURANCE_BY_ICD_MESSAGE || '',
          if_your_insurance_is_not_available_in_the_list_please_select_other: '*If your insurance is not available in the list please select Other',
          client_bill: 'Client Bill',
          select_payment_type: 'Select Payment Type',
          upload_insurance_card: 'Now upload or take a picture <b> of your insurance card</b>',
          insurance: 'Insurance',
          uninsured: 'Uninsured',
          cash: 'Cash',
          please_provide_payment_information: 'Please Provide Payment Information',
          primary_insurance_name: 'Primary Insurance Name',
          primary_insurance_name_input: 'Insurance Name',
          policy_number: 'Policy Number',
          group_number: 'Group Number',
          insurance_card: 'Insurance Card',
          note: 'Note',
          patient_relationship_to_insured: 'Patient Relationship to Insured',
          insured_address: 'Insured Address',
          insured_address2: 'Insured Address 2',
          after_registration_you_will_be_redirected_to_a_payment_page: 'After registration you will be redirected to a payment page',
          social_security_number: 'Social Security Number',
          driver_license_number: 'Driver License Number',
          insured_first_name: 'Insured First Name',
          insured_middle_name: 'Insured Middle Name',
          insured_last_name: 'Insured Last Name',
          insured_date_of_birth: 'Insured Date of Birth',
          insured_gender: 'Insured Gender',
          please_answer_to_the_best_of_your_knowledge: 'Please answer to the best of your knowledge',
          above_please_tell_us_more_about_yourself: 'The new Federal Mandate for Covid Testing requires ALL patient info to be accurate. Incorrect patient info may delay results or result in the sample being rejected.',
          please_tell_us_more_about_yourself: 'Please tell us more about yourself',
          answer_required: 'Answer required'
        },
        generalClass: 'general-inactive-section',
        validatedSectionClass: '',
        validationObject: {
          selectedBill: false,
          relationship: false,
          primary_insurance: false,
          primary_insurance_name_input: false,
          policy_number: false,
          insured_first_name: false,
          insured_middle_name: !this.checkRequirement('insured_middle_name'),
          insured_last_name: false,
          insured_date_of_birth: false,
          insured_gender: false,
          insured_address: false,
          insured_card_name: false,
          uninsured_ssn: false,
          insurance_ssn: false,
          disclaimer_payment: false,
          questions: false
        },
        model: {
          selectedBill: '',
          relationship: this.$store.state.userData['relationship'] || '',
          driver_license_number: this.$store.state.userData['driver_license_number'] || '',
          social_security_number: this.$store.state.userData['social_number'] || '',
          primary_insurance: this.$store.state.userData['primary_insurance'] || '',
          primary_insurance_name_input: '',
          policy_number: this.$store.state.userData['policy_number'] || '',
          group_number: this.$store.state.userData['group_number'] || '',
          insurance_pay: '',
          insurance_card_images: [],
          insurance_card_names: [],
          error_uninsured: '',
          insured_gender: this.$store.state.userData['insured_gender'] || '',
          insured_first_name: this.$store.state.userData['insured_first_name'] || '',
          insured_middle_name: this.$store.state.userData['insured_middle_name'] || '',
          insured_last_name: this.$store.state.userData['insured_last_name'] || '',
          insured_date_of_birth: this.$store.state.userData['insured_date_of_birth'] || '',
          insured_date_of_birth_pretty: this.$store.state.userData['insured_date_of_birth_pretty'] || '',
          insured_address_components: this.$store.state.userData['insured_address_components'] || '',
          insured_address: this.$store.state.userData['insured_address'] || '',
          insured_address2: this.$store.state.userData['insured_address2'] || '',
          note: ''
        },
        relationshipList: [{value: 'Self', label: 'Self'}, {value: 'Child', label: 'Child'}, {value: 'Parent', label: 'Parent'}, {value: 'Spouse', label: 'Spouse'}],
        modelValidations: {
          primary_insurance: {
            required: true
          },
          primary_insurance_name_input: {
            required: true
          },
          policy_number: {
            min: 2,
            required: true
          },
          group_number: {
          },
          insurance_card_image: {
            required: this.$store.state.configs.REQUIRED_INSURANCE_CARD
          },
          driver_license_number: {
          },
          insured_first_name: {
            required: true
          },
          insured_middle_name: {
            required: this.checkRequirement('insured_middle_name')
          },
          insured_last_name: {
            required: true
          },
          relationship: {
            required: true
          },
          insured_gender: {
            required: true
          },
          insured_address: {
            min: 5,
            required: true
          },
          insured_address2: {},
          social_security_number: {
            min: 11,
            max: 11
          },
          error_uninsured: {}
        },
        address_smartystreets_selected: {
          invalid: false,
          error_message: 'Looks like we don\'t know this address, please make sure the address is correct',
          first_result: ''
        }
      }
    },
    methods: {
      validateAddress (objectAddress, excludedValues) {
        let flag = true
        for (let iterator in objectAddress) {
          if (!excludedValues.includes(iterator)) {
            if (objectAddress[iterator] === '') {
              flag = false
            }
          }
        }
        if (flag) {
          return true
        }
        return false
      },
      checkValidationField (fieldName) {
        if (this.model[fieldName]) {
          this.validationObject[fieldName] = true
        } else {
          this.validationObject[fieldName] = false
        }
      },
      validateSignature (boolean) {
        this.validationObject.disclaimer_payment = boolean
      },
      computeFirstInsuranceType () {
        if (this.$store.state.site.insurance_name_insured.findIndex((element) => { return element[0] === this.model.selectedBill }) !== -1) {
          this.model.insurance_pay = 'insurance'
        } else if (this.$store.state.site.insurance_name_uninsured.findIndex((element) => { return element[0] === this.model.selectedBill }) !== -1) {
          this.model.insurance_pay = 'uninsured'
        } else if (this.$store.state.site.insurance_name_cash.findIndex((element) => { return element[0] === this.model.selectedBill }) !== -1) {
          if (this.allow_payment && this.paymentMethod === 'card') {
            this.$store.state.cashPayment = 'card'
          }
          this.model.insurance_pay = 'cash'
        } else if (this.$store.state.site.insurance_name_client_bill.findIndex((element) => { return element[0] === this.model.selectedBill }) !== -1) {
          this.model.insurance_pay = 'client_bill'
        }

        this.$store.state.insuranceType = this.model.insurance_pay
      },
      formBillVector () {
        if (!this.$store.state.site.insurance_all) {
          this.model.selectedBill = ''
          let bill
          this.allBills = []
          if (this.$store.state.site.insurance_name_insured) {
            if (this.$store.state.configs.RESTRICT_INSURANCE_BY_ICD === true) {
              if (this.$store.state.icdCodes.length) {
                for (bill in this.$store.state.site.insurance_name_insured) {
                  this.allBills.push(this.$store.state.site.insurance_name_insured[bill])
                }
              }
            } else {
              for (bill in this.$store.state.site.insurance_name_insured) {
                this.allBills.push(this.$store.state.site.insurance_name_insured[bill])
              }
            }
          }
          for (bill in this.$store.state.site.insurance_name_uninsured) {
            this.allBills.push(this.$store.state.site.insurance_name_uninsured[bill])
          }
          if (this.allow_payment) {
            for (bill in this.$store.state.site.insurance_name_cash) {
              this.allBills.push(this.$store.state.site.insurance_name_cash[bill])
            }
          }
          for (bill in this.$store.state.site.insurance_name_client_bill) {
            this.allBills.push(this.$store.state.site.insurance_name_client_bill[bill])
          }
          this.allBills = this.allBills.sort((firstEl, secondEl) => {
            if (firstEl[1] === null) { firstEl[1] = '999' }
            if (secondEl[1] === null) { secondEl[1] = '999' }
            return parseInt(firstEl[1]) <= parseInt(secondEl[1]) ? -1 : 1
          })
          if (this.model.selectedBill === '' && this.allBills.length) {
            this.model.selectedBill = this.allBills[0][0]
          }
          this.switchInsuranceCash()
        }
      },
      updateAddress (data) {
        this.model.insured_address_components = data
        this.address_error = ''
      },
      updateAddress2 (data) {
        this.model.insured_address2 = data
      },
      async switchInsuranceCash () {
        await this.computeFirstInsuranceType()
        this.$store.state.cashPayment = ''
        if (this.model.insurance_pay === 'uninsured') {
          this.changePaymentValue('UNINSURED')
        } else {
          if (this.model.insurance_pay === 'cash') {
            if (this.allow_payment && this.paymentMethod === 'card') {
              this.$store.state.cashPayment = 'card'
            }
            this.changePaymentValue('CASH')
          } else {
            if (this.model.insurance_pay === 'client_bill') {
              this.changePaymentValue('CLIENT BILL')
            } else {
              this.changePaymentValue('')
            }
          }
        }
        this.validateComponent()
      },
      switchCashPayment () {
        this.$store.state.cashPayment = ''
        if (this.paymentMethod === 'card') {
          this.$store.state.cashPayment = 'card'
        }
      },
      changePaymentValue (type) {
        this.errorDate = ''
        if (type !== 'UNINSURED') {
          this.model.driver_license_number = ''
          this.model.social_security_number = ''
        }
        if (this.model.insurance_pay === 'insurance') {
          this.model.primary_insurance = this.$store.state.userData['primary_insurance'] || ''
          if (this.model.primary_insurance === 'Other') {
            this.model.primary_insurance_name_input = this.getPolicyOrInsurance(this.$store.state.userData['policy_number'] || '', false)
            this.model.policy_number = this.getPolicyOrInsurance(this.$store.state.userData['policy_number'] || '', true)
          } else {
            this.model.primary_insurance_name_input = ''
            this.model.policy_number = this.$store.state.userData['policy_number'] || ''
          }
        } else {
          this.model.primary_insurance = type
          this.model.policy_number = type
        }
        this.model.group_number = this.$store.state.userData['group_number'] || ''
      },
      createFilter (queryString) {
        return (link) => {
          return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      isValidMultipleInput (valid) {
        if (valid) {
          this.validationObject.insured_card_name = true
        } else {
          this.validationObject.insured_card_name = false
        }
      },
      getPolicyOrInsurance (policyNumber, policyBoolean) {
        if (policyBoolean) {
          policyNumber = (policyNumber.indexOf('-') !== -1) ? policyNumber.slice(policyNumber.indexOf('-') + 2) : policyNumber
          return policyNumber
        } else {
          let insuranceName = policyNumber.slice(0, policyNumber.indexOf('-') - 1)
          return insuranceName
        }
      },
      async validate () {
        let info = await this.getPatientInfo()
        this.submit = true
        let validator = true
        let questionValidation = this.validateQuestions(this.$store.state.questions, validator, this.model.selectedBill)
        this.validationObject.questions = questionValidation !== false
        if (!questionValidation) {
          this.$refs.questions.focusQuestions()
          return false
        }
        await this.$refs.ConsentDisclaimer.validate()
        await this.$validator.validateAll()
        if (this.model.primary_insurance === 'Other' && this.model.primary_insurance_name_input !== '' && this.model.policy_number !== '' && this.$validator.errors.items.length === 0) {
          this.model.policy_number = this.model.primary_insurance_name_input + ' - ' + this.model.policy_number
        }
        if (this.$validator.errors.items.length) {
          document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
          this.$store.state.insuranceValidator = false
        }
        if (this.model.insurance_pay === 'uninsured') {
          if (this.required_dl_or_ssn) {
            if (!this.model.driver_license_number && !this.model.social_security_number) {
              this.$validator.errors.add({field: 'error_uninsured', msg: 'Please complete your Driver License Number or your Social Number'})
              let field = this.$validator._resolveField('error_uninsured')
              field.setFlags({invalid: true})
              document.getElementsByName('driver_license_number')[0].focus()
              this.$store.state.insuranceValidator = false
              return false
            }
          }
          if (this.$store.state.required_uninsured_ssn && !this.model.social_security_number) {
            this.$validator.errors.add({field: 'social_security_number', msg: 'Social Security Number field is required'})
            let field = this.$validator._resolveField('social_security_number')
            field.setFlags({invalid: true})
            this.$store.state.insuranceValidator = false
            return false
          }
        }
        if (this.model.insurance_pay === 'insurance') {
          if (this.$store.state.dependentSelected) {
            this.model.insurance_same_as = this.checked ? '1' : '0'
          }
          if (this.$store.state.required_insurance_ssn && !this.model.social_security_number) {
            this.$validator.errors.add({field: 'social_security_number', msg: 'Social Security Number field is required'})
            let field = this.$validator._resolveField('social_security_number')
            field.setFlags({invalid: true})
            document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
            this.$store.state.insuranceValidator = false
            return false
          }
          if (!this.model.insured_date_of_birth && this.model.insurance_pay === 'insurance') {
            this.errorDate = 'Insured Date Of Birth field is required'
            if (this.$validator.errors.items.length === 2) {
              document.getElementsByName('insured_date_of_birth_pretty')[0].focus()
            }
          } else if (!this.errorDate.includes('must be valid')) {
            this.errorDate = ''
          }
          if (this.checkRequirement('insured_address')) {
            this.address_error = ''
            let validateAddress = this.$refs.AddressComponent.validate()
            if (!validateAddress) {
              this.address_error = 'All the fields are required'
              return false
            }
          }
           // call insurance card images validation
          if (this.allow_insurance_card) {
            let insuranceCardArr = await this.$refs.insuranceCard.validate()
            if (insuranceCardArr !== false && insuranceCardArr !== undefined && insuranceCardArr.length > 0) {
              this.model.insurance_card_images = insuranceCardArr[0]
              this.model.insurance_card_names = insuranceCardArr[1]
            } else {
              if (this.required_insurance_card) {
                return false
              }
            }
          }
          if (_.get(this.$store.state.configs, 'VALIDATE_INSURANCE_WITH_API', null)) {
            // build object for api call, if api call is true, reset error, else return false with error message
            let insuredData = {
              'insurance_name': this.model.primary_insurance,
              'first_name': this.model.insured_first_name,
              // 'middle_name': '',
              'middle_name': this.model.insured_middle_name,
              'last_name': this.model.insured_last_name,
              'date_of_birth': this.model.insured_date_of_birth,
              'policy_number': this.model.policy_number,
              'info': info
            }
            let scopeValidation = true
            await axios.post(process.env.SERVER_URI + '/check/insurance', insuredData)
              .then((response) => {
                if (response['data']['data']['success'] === false) {
                  document.getElementsByName('insurance-component')[0].scrollIntoView({
                    behavior: 'smooth',
                    block: 'end'
                  })
                  this.errorMessage = this.computeCaption('Insurance is invalid, please take a closer look at the completed fields and retry', this.$store.state.lang)
                  scopeValidation = false
                } else if (response['data']['data']['eligible'] === true) {
                  this.errorMessage = ''
                } else {
                  document.getElementsByName('insurance-component')[0].scrollIntoView({
                    behavior: 'smooth',
                    block: 'end'
                  })
                  scopeValidation = false
                  this.errorMessage = this.computeCaption('Insurance is invalid, please take a closer look at the completed fields and retry', this.$store.state.lang)
                }
              })
            if (scopeValidation === true) { return true } else { return false }
          }
        }
        if ((await this.$validator.validateAll() === true) && this.errorDate === '' && this.address_error === '' && Object.values(this.validationObject).every(field => field === true)) {
          this.$store.state.registrationInsuranceData = this.model
          this.$store.state.insuranceValidator = true
          return true
        } else {
          if (this.$validator.errors.items.length) {
            document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
          }
          this.$store.state.insuranceValidator = false
          return false
        }
      },
      validateComponent () {
        if (this.model.insurance_pay !== 'insurance') {
          Object.entries(this.validationObject).forEach(([key, value]) => {
            this.validationObject[key] = true
          })
          if (this.model.insurance_pay === 'uninsured') {
            if (this.$store.state.required_uninsured_ssn) {
              this.validationObject.uninsured_ssn = false
            }
          }
        } else {
          this.model.relationship = this.$store.state.userData['relationship'] || ''
          this.validationObject.selectedBill = true
          this.validationObject.uninsured_ssn = true
          if (this.model.primary_insurance === 'Other') {
            this.checkValidationField('primary_insurance_name_input')
          } else {
            this.validationObject.primary_insurance_name_input = true
          }
          this.checkValidationField('insured_first_name')
          if (this.modelValidations.insured_middle_name.required) {
            this.checkValidationField('insured_middle_name')
          }
          this.checkValidationField('insured_last_name')
          this.checkValidationField('insured_gender')
          this.checkValidationField('insured_address')
          this.checkValidationField('relationship')
          this.checkValidationField('policy_number')
          this.checkValidationField('insured_date_of_birth')
          if (this.$store.state.required_insurance_ssn && this.model.social_security_number) {
            this.validationObject.insurance_ssn = true
          } else {
            if (!this.$store.state.required_insurance_ssn) {
              this.validationObject.insurance_ssn = true
            } else {
              this.validationObject.insurance_ssn = false
            }
          }
          if (!this.checkRequirement('gender')) {
            this.validationObject.insured_gender = true
          }
          if (this.required_insurance_card && this.allow_insurance_card) {
            this.validationObject.insured_card_name = false
          } else {
            this.validationObject.insured_card_name = true
          }
          if (this.checked) {
            if (this.model.relationship === '') {
              this.validationObject.relationship = false
            }
          }
        }
        if (this.$store.state.userData.primary_insurance) {
          this.validationObject.primary_insurance = true
        } else {
          this.validationObject.primary_insurance = false
        }
        // disclaimer check
        for (let i = 0; i < this.allBills.length; i++) {
          if (this.allBills[i][0] === this.model.selectedBill) {
            this.disclaimer = this.allBills[i][2]
            if (this.allBills[i][3] === '0' || this.disclaimer === undefined) {
              this.allowSignatureDisclaimer = false
            } else {
              this.allowSignatureDisclaimer = true
            }
          }
        }
        if (this.disclaimer !== null && this.disclaimer !== '' && this.disclaimer !== undefined || this.allowSignatureDisclaimer) {
          this.allowDisclaimer = true
        } else {
          this.allowDisclaimer = false
          this.validationObject.disclaimer_payment = true
        }
        if (this.allowSignatureDisclaimer) {
          this.validationObject.disclaimer_payment = false
        }
        if (this.allowDisclaimer) {
          if (this.allowSignatureDisclaimer) {
            setTimeout(() => {
              this.$refs.ConsentDisclaimer.clearDisclaimerSignature()
              this.validationObject.disclaimer_payment = false
            }, 100)
          } else {
            this.$refs.ConsentDisclaimer.agreeDisclaimer = false
            this.validationObject.disclaimer_payment = false
          }
        } else {
          this.validationObject.disclaimer_payment = true
        }
      }
    },
    computed: {
      hide_self_completed_fields () {
        return this.$store.state.configs.HIDE_SELF_COMPLETED_FIELDS
      },
      required_dl_or_ssn () {
        return this.$store.state.dl_or_ssn_required_by_client
      },
      allow_dl_or_ssn () {
        return this.$store.state.allow_dl_or_ssn
      },
      insurance_pay: {
        model: {
          get () {
            return this.model.insurance_pay
          },
          set (value) {
            this.$emit('input', value)
          }
        }
      },
      hide_pay_at_collection () {
        return this.$store.state.configs.HIDE_PAY_AT_COLLECTION
      },
      hide_pay_with_card () {
        return this.$store.state.configs.HIDE_PAY_WITH_CARD
      },
      ...mapFields(['primary_insurance', 'primary_insurance_name_input', 'policy_number', 'group_number', 'insurance_pay', 'insured_first_name', 'insured_middle_name', 'insured_last_name', 'insured_date_of_birth', 'insured_date_of_birth_pretty', 'insured_gender', 'insured_address', 'insured_address2', 'error_uninsured', 'social_security_number', 'relationship'])
    },
    watch: {
      'model.insured_date_of_birth_pretty': {
        handler: function (dobValue) {
          if (dobValue !== '' && dobValue.length !== 10 && (this.model.insurance_pay === 'insurance')) {
            let dateCleave = new Cleave('.date-insured-cleave-format', {
              date: true,
              delimiter: '/',
              datePattern: ['m', 'd', 'Y']
            })
            this.model.insured_date_of_birth_pretty = dateCleave.getFormattedValue()
          }
          if (dobValue.length === 10) {
            let dateParts = dobValue.split('/')
            this.model.insured_date_of_birth = dateParts[2] + '-' + dateParts[0] + '-' + dateParts[1]
            if (this.isFutureDate(dobValue) || this.isOldDate(dobValue)) {
              this.validationObject.insured_date_of_birth = false
            } else {
              this.validationObject.insured_date_of_birth = true
            }
          } else {
            if (this.model.insurance_pay === 'insurance') {
              this.validationObject.insured_date_of_birth = false
            }
          }
        },
        deep: true
      },
      'model.social_security_number': {
        handler: function (after, before) {
          if (this.$store.state.site.insurance_name_uninsured.findIndex((element) => { return element[0] === this.model.selectedBill }) !== -1) {
            if (after.length < this.modelValidations.social_security_number.min) {
              let ssnCleave = new Cleave('.ssn-cleave-format1', {
                delimiters: ['-', '-'],
                numericOnly: true,
                uppercase: true,
                blocks: [3, 2, 4]
              })
              this.model.social_security_number = ssnCleave.getFormattedValue()
            } else if (after.length > this.modelValidations.social_security_number.max) {
              this.model.social_security_number = this.model.social_security_number.substr(0, this.model.social_security_number.length - 1)
            }
            if (after.length === 11) {
              if (this.$store.state.required_uninsured_ssn) {
                this.validationObject.uninsured_ssn = true
              }
            } else {
              if (!this.$store.state.required_uninsured_ssn) {
                this.validationObject.uninsured_ssn = true
              } else {
                this.validationObject.uninsured_ssn = false
              }
            }
          }
        },
        deep: true
      },
      'checked': {
        handler: function (after, before) {
          if (this.checked === true && this.$store.state.dependentSelected) {
            this.relationshipList = [{value: 'Child', label: 'Child'}, {value: 'Parent', label: 'Parent'}, {value: 'Spouse', label: 'Spouse'}]
            this.model.primary_insurance = this.$store.state.patientRegistrationData['primary_insurance'] || ''
            if (this.$store.state.userData['primary_insurance'] === 'Other') {
              this.model.primary_insurance_name_input = this.getPolicyOrInsurance(this.$store.state.userData['policy_number'] || '', false)
              this.model.policy_number = this.getPolicyOrInsurance(this.$store.state.userData['policy_number'] || '', true)
            } else {
              this.model.primary_insurance_name_input = ''
              this.model.policy_number = this.$store.state.userData['policy_number'] || ''
            }
            this.model.group_number = this.$store.state.patientRegistrationData['group_number'] || ''
            this.model.insured_first_name = this.$store.state.patientRegistrationData['insured_first_name'] || ''
            this.model.insured_middle_name = this.$store.state.patientRegistrationData['insured_middle_name'] || ''
            this.model.insured_last_name = this.$store.state.patientRegistrationData['insured_last_name'] || ''
            this.model.insured_gender = this.$store.state.patientRegistrationData['insured_gender'] || ''
            this.model.insured_date_of_birth = this.$store.state.patientRegistrationData['dob'] || ''
            this.model.insured_date_of_birth_pretty = this.$store.state.patientRegistrationData['dob_pretty'] || ''
            this.model.insured_address_components = this.$store.state.patientRegistrationData['insured_address_components'] || ''
            this.model.insured_address = this.$store.state.patientRegistrationData['insured_address'] || ''
            this.insuredAddress += 1
            this.updateAddress(this.model.insured_address_components)
            if (this.model.insured_date_of_birth_pretty) {
              if (this.model.insured_date_of_birth_pretty.length === 10) {
                this.model.insured_date_of_birth_pretty = this.$store.state.patientRegistrationData.dob.substring(5, 7) + '/' + this.$store.state.patientRegistrationData.dob.substring(8, 10) + '/' + this.$store.state.patientRegistrationData.dob.substring(0, 4)
              }
            }
          } else if (this.checked === false && this.$store.state.dependentSelected) {
            this.relationshipList = [{value: 'Self', label: 'Self'}]
            this.model.primary_insurance = this.$store.state.userData['primary_insurance'] || ''
            if (this.$store.state.userData['primary_insurance'] === 'Other') {
              this.model.primary_insurance_name_input = this.getPolicyOrInsurance(this.$store.state.userData['policy_number'] || '', false)
              this.model.policy_number = this.getPolicyOrInsurance(this.$store.state.userData['policy_number'] || '', true)
            } else {
              this.model.primary_insurance_name_input = ''
              this.model.policy_number = this.getPolicyOrInsurance(this.$store.state.userData['policy_number'] || '', true)
            }
            this.model.group_number = this.$store.state.userData['group_number'] || ''
            this.model.insured_first_name = this.$store.state.userData['insured_first_name'] || ''
            this.model.insured_middle_name = this.$store.state.userData['insured_middle_name'] || ''
            this.model.insured_last_name = this.$store.state.userData['insured_last_name'] || ''
            this.model.insured_gender = this.$store.state.userData['insured_gender'] || ''
            this.model.insured_date_of_birth = this.$store.state.userData['insured_date_of_birth'] || ''
            this.model.insured_date_of_birth_pretty = this.$store.state.userData['insured_date_of_birth'] || ''
            this.model.insured_address_components = this.$store.state.userData['insured_address_components'] || ''
            this.model.insured_address = this.$store.state.userData['insured_address'] || ''
            this.insuredAddress += 1
            this.updateAddress(this.model.insured_address_components)
            if (this.model.insured_date_of_birth_pretty) {
              if (this.model.insured_date_of_birth_pretty.length === 10) {
                this.model.insured_date_of_birth_pretty = this.$store.state.userData.insured_date_of_birth.substring(5, 7) + '/' + this.$store.state.userData.insured_date_of_birth.substring(8, 10) + '/' + this.$store.state.userData.insured_date_of_birth.substring(0, 4)
              }
            }
          }
        }
      },
      'model.relationship': {
        handler: function (before, after) {
          if (this.model.relationship === 'Self') {
            this.model.insured_last_name = this.$store.state.insuranceData.lastName
            this.model.insured_first_name = this.$store.state.insuranceData.firstName
            this.model.insured_middle_name = this.$store.state.insuranceData.middleName
            this.model.insured_gender = this.$store.state.insuranceData.gender
            this.model.insured_date_of_birth = this.$store.state.insuranceData.dob
            this.model.insured_date_of_birth_pretty = this.$store.state.insuranceData.dob_pretty
            this.model.insured_address_components = this.$store.state.insuranceData.addressComponents
            this.updateAddress(this.model.insured_address_components)
            this.model.insured_address = this.$store.state.insuranceData.address
            this.model.insured_address2 = this.$store.state.insuranceData.address2
            this.insuredAddress += 1
          } else {
            let checkedAtTheMoment = this.checked
            this.checked = false
            this.$nextTick(() => {
              this.checked = checkedAtTheMoment
            })
          }
          if (this.model.insurance_pay === 'insurance') {
            if (this.model.relationship) {
              this.validationObject.relationship = true
            } else {
              this.validationObject.relationship = false
            }
          }
        }
      },
      '$store.state.insuranceData.firstName': {
        handler: function (before, after) {
          if (this.model.relationship === 'Self') {
            this.model.insured_first_name = this.$store.state.insuranceData.firstName
          }
        }
      },
      '$store.state.insuranceData.middleName': {
        handler: function (before, after) {
          if (this.model.relationship === 'Self') {
            this.model.insured_middle_name = this.$store.state.insuranceData.middleName
          }
        }
      },
      '$store.state.insuranceData.dob': {
        handler: function (before, after) {
          if (this.model.relationship === 'Self') {
            this.model.insured_date_of_birth = this.$store.state.insuranceData.dob
            this.model.insured_date_of_birth_pretty = this.$store.state.insuranceData.dob_pretty
          }
        }
      },
      '$store.state.insuranceData.lastName': {
        handler: function (before, after) {
          if (this.model.relationship === 'Self') {
            this.model.insured_last_name = this.$store.state.insuranceData.lastName
          }
        }
      },
      '$store.state.insuranceData.gender': {
        handler: function (before, after) {
          if (this.model.relationship === 'Self') {
            this.model.insured_gender = this.$store.state.insuranceData.gender
          }
        }
      },
      '$store.state.insuranceData.addressComponents': {
        handler: function (before, after) {
          if (this.model.relationship === 'Self') {
            this.model.insured_address_components = this.$store.state.insuranceData.addressComponents
            this.updateAddress(this.model.insured_address_components)
            this.model.insured_address = this.$store.state.insuranceData.address
            this.insuredAddress += 1
          }
        },
        deep: true
      },
      '$store.state.site.insurance_name_client_bill': {
        handler (before, after) {
          if (this.allBills.length === 0) {
            this.formBillVector()
          }
        }
      },
      '$store.state.site.insurance_name_insurance': {
        handler (before, after) {
          if (this.allBills.length === 0) {
            this.formBillVector()
          }
        }
      },
      '$store.state.site.insurance_name_uninsured': {
        handler (before, after) {
          if (this.allBills.length === 0) {
            this.formBillVector()
          }
        }
      },
      '$store.state.site.insurance_name_cash': {
        handler (before, after) {
          if (this.allBills.length === 0) {
            this.formBillVector()
          }
        }
      },
      'model.insurance_pay': {
        handler: function (value) {
          if (this.$store.state.userData.primary_insurance) {
            this.validationObject.primary_insurance = true
          } else {
            this.validationObject.primary_insurance = false
          }
        }
      },
      'allowDisclaimer': {
        handler (value) {
          if (this.allowDisclaimer) {
            if (this.allowSignatureDisclaimer) {
              setTimeout(() => {
                this.$refs.ConsentDisclaimer.clearDisclaimerSignature()
                this.validationObject.disclaimer_payment = false
              }, 100)
            } else {
              this.$refs.ConsentDisclaimer.agreeDisclaimer = false
              this.validationObject.disclaimer_payment = false
            }
          } else {
            this.validationObject.disclaimer_payment = true
          }
        }
      },
      'model.selectedBill': {
        async handler (before, after) {
          await this.computeFirstInsuranceType()
          if (this.$store.state.site.insurance_name_uninsured.findIndex((element) => { return element[0] === this.model.selectedBill }) !== -1) {
            this.model.social_security_number = this.$store.state.personIdentifierSection.med_social_security_number
            this.model.driver_license_number = this.$store.state.personIdentifierSection.med_driver_license_number
          }
          this.$store.state.selectedBill = this.model.selectedBill
          let validator = true
          let questionValidation = this.validateQuestions(this.$store.state.questions, validator, this.model.selectedBill)
          this.validationObject.questions = questionValidation !== false
        }
      },
      '$store.state.questions': {
        handler (before, after) {
          this.$store.state.icdCodes = []
          let validator = true
          let questionValidation = this.validateQuestions(this.$store.state.questions, validator)
          if (questionValidation === false) {
            this.$store.state.icdCodes = []
          }
          validator = true
          questionValidation = this.validateQuestions(this.$store.state.questions, validator, this.model.selectedBill)
          this.validationObject.questions = questionValidation !== false
        },
        deep: true
      },
      '$store.state.icdCodes': {
        handler (after, before) {
          if (before.length === 0 && this.$store.state.icdCodes.length && this.$store.state.configs.RESTRICT_INSURANCE_BY_ICD === true) {
            this.formBillVector()
            this.insuranceKey += Math.floor(Math.random() * 1950) + 1000
          } else if (!this.$store.state.icdCodes.length && this.$store.state.configs.RESTRICT_INSURANCE_BY_ICD === true) {
            this.formBillVector()
            this.insuranceKey += Math.floor(Math.random() * 1950) + 1000
          }
        },
        deep: true
      },
      '$store.state.personIdentifierSection': {
        handler: function (before, after) {
          this.model.social_security_number = this.$store.state.personIdentifierSection.med_social_security_number
          this.model.driver_license_number = this.$store.state.personIdentifierSection.med_driver_license_number
        }
      },
      'validationObject': {
        handler (before, after) {
          if (Object.values(this.validationObject).every(field => field === true)) {
            this.validatedSectionClass = 'validated-section-class'
            this.generalClass = 'general-inactive-section'
          } else {
            this.validatedSectionClass = 'invalid-section-class'
            this.generalClass = 'general-invalid-section'
          }
        },
        deep: true
      },
      'model.insured_first_name': {
        handler: function (value) {
          if (this.model.insurance_pay === 'insurance') {
            if (this.model.insured_first_name) {
              this.validationObject.insured_first_name = true
            } else {
              this.validationObject.insured_first_name = false
            }
          }
        }
      },
      'model.insured_middle_name': {
        handler: function (value) {
          if (this.model.insurance_pay === 'insurance') {
            if (this.modelValidations.insured_middle_name.required) {
              if (this.model.insured_middle_name) {
                this.validationObject.insured_middle_name = true
              } else {
                this.validationObject.insured_middle_name = false
              }
            } else {
              this.validationObject.insured_middle_name = true
            }
          }
        }
      },
      'model.insured_last_name': {
        handler: function (value) {
          if (this.model.insurance_pay === 'insurance') {
            if (this.model.insured_last_name) {
              this.validationObject.insured_last_name = true
            } else {
              this.validationObject.insured_last_name = false
            }
          }
        }
      },
      'model.insured_gender': {
        handler: function (value) {
          if (this.model.insurance_pay === 'insurance') {
            if (this.model.insured_gender || !this.checkRequirement('gender')) {
              this.validationObject.insured_gender = true
            } else {
              this.validationObject.insured_gender = false
            }
          }
        }
      },
      'model.policy_number': {
        handler: function (value) {
          if (this.model.policy_number || this.model.insurance_pay !== 'insurance') {
            this.validationObject.policy_number = true
          } else {
            this.validationObject.policy_number = false
          }
        }
      },
      'model.primary_insurance': {
        handler: function (value) {
          if (this.model.primary_insurance) {
            this.validationObject.primary_insurance = true
          } else {
            this.validationObject.primary_insurance = false
          }
          if (value === 'Other') {
            if (this.model.primary_insurance_name_input) {
              this.validationObject.primary_insurance_name_input = true
            } else {
              this.validationObject.primary_insurance_name_input = false
            }
          } else {
            this.validationObject.primary_insurance_name_input = true
          }
        }
      },
      'model.primary_insurance_name_input': {
        handler: function (value) {
          if (this.model.primary_insurance === 'Other') {
            if (this.model.primary_insurance_name_input) {
              this.validationObject.primary_insurance_name_input = true
            } else {
              this.validationObject.primary_insurance_name_input = false
            }
          } else {
            this.validationObject.primary_insurance_name_input = true
          }
        }
      },
      'model.insured_address_components': {
        handler: function (value) {
          if (this.model.insurance_pay === 'insurance') {
            if (this.checkRequirement('address')) {
              let excludedValues = []
              if (this.$store.state.international) {
                excludedValues = ['name', 'original_name', 'plus4_code', 'zipcode', 'state_abbreviation', 'county_fips']
              } else {
                if (this.force_valid_address) {
                  excludedValues = ['name', 'original_name', 'plus4_code']
                } else {
                  excludedValues = ['name', 'original_name', 'plus4_code', 'county_fips']
                }
              }
              if (Object.keys(this.model.insured_address_components).length > 0 && this.validateAddress(this.model.insured_address_components, excludedValues)) {
                this.validationObject.insured_address = true
              } else {
                this.validationObject.insured_address = false
              }
            } else {
              this.validationObject.insured_address = true
            }
          }
        },
        deep: true
      },
      '$store.state.user': {
        handler: function (value) {
          let vue = this
          this.$store.state.calculations.map((calc) => {
            if (vue) {
              // eslint-disable-next-line no-eval
              eval(calc['code'])
            }
          })
        },
        deep: true
      }
    },
    beforeMount () {
      this.$store.state.international = false
      this.model.insurance_pay = 'insurance'
      this.formBillVector()
      this.model.relationship = this.$store.state.userData['relationship'] || ''
      this.model.insured_first_name = this.$store.state.userData['insured_first_name'] || ''
      this.model.insured_middle_name = this.$store.state.userData['insured_middle_name'] || ''
      this.model.insured_last_name = this.$store.state.userData['insured_last_name'] || ''
      this.model.insured_date_of_birth = this.$store.state.userData['insured_date_of_birth'] || ''
      this.model.insured_date_of_birth_pretty = this.$store.state.userData['insured_date_of_birth_pretty'] || ''
      this.model.insured_address = this.$store.state.userData['insured_address'] || ''
      this.model.insured_gender = this.$store.state.userData['insured_gender'] || ''
      this.model.insured_address_components = this.$store.state.userData['insured_address_components'] || ''
      if (this.$store.state.userData['primary_insurance'] === 'Other') {
        this.model.primary_insurance_name_input = this.getPolicyOrInsurance(this.$store.state.userData['policy_number'] || '', false)
        this.model.policy_number = this.getPolicyOrInsurance(this.$store.state.userData['policy_number'] || '', true)
      } else {
        this.model.primary_insurance_name_input = ''
        this.model.policy_number = this.getPolicyOrInsurance(this.$store.state.userData['policy_number'] || '', true)
      }
      if (!this.checkRequirement('gender')) {
        this.validationObject.insured_gender = true
      }
      this.model.group_number = this.$store.state.userData['group_number'] || ''
      if (this.$store.state.sitecode !== false) {
        if (this.model.insured_date_of_birth_pretty) {
          if (this.model.insured_date_of_birth_pretty.length === 10) {
            this.model.insured_date_of_birth_pretty = this.$store.state.userData.insured_date_of_birth_pretty.substring(5, 7) + '/' + this.$store.state.userData.insured_date_of_birth_pretty.substring(8, 10) + '/' + this.$store.state.userData.insured_date_of_birth_pretty.substring(0, 4)
          }
        }
        this.updateAddress(this.model.insured_address_components)
      }
      if (this.$store.state.dependentSelected) {
        this.checked = this.$store.state.userData['insured_same_as'] === '1'
      }
      let vue = this
      this.$store.state.calculations.map((calc) => {
        if (calc['name'] === 'Patient Portal Bill Calculation' && vue) {
          // eslint-disable-next-line no-eval
          eval(calc['code'])
        }
      })
      if (!this.hide_pay_at_collection && !this.hide_pay_with_card) {
        this.paymentMethod = 'card'
      } else if (this.hide_pay_at_collection) {
        this.paymentMethod = 'card'
      } else if (this.hide_pay_with_card) {
        this.paymentMethod = 'site'
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '../../../../../assets/sass/paper/_variables.scss';

>>> .el-select--large{
      width: 100%;
    }

>>> .el-autocomplete{
      width: 100%;
    }
  .disclaimer {
    font-size: 13px;
    color: green;
  }
  h5{
    margin-bottom: 25px;
  }

  .display-none {
    display: none;
  }

  .generic-answer {
    margin-top: 10px;
  }

  .float-right{
    float: right;
  }

  .p-0{
    padding: 0;
  }

  .w-100{
    width: 100% !important;
  }

  .pr-0{
    padding-right: 0;
  }

  .p-10{
    padding: 10px;
  }

  .green-border{
    border: 1px dashed $primary-color;
    background-color: #FCFCFC;
  }

  .general-inactive-section:focus-within {
    border-left-color: $primary-color !important;
  }

  @media screen and (max-width: 991px) {
    .pr-0{
      padding-left: 0;
    }
  }

  .pt-10{
    padding-top: 10px;
  }

  .scan-button{
    font-size: 17px;
    background: white;
    border: 1px solid red;
    border-radius: 5px;
  }

  .line-clamp {
    text-overflow: ellipsis;
    overflow: hidden;
    /* width: 500px; */
    height: 1.2em;
    white-space: nowrap;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  .d-inline-block{
    display: inline-block;
  }

  .mt-5{
    margin-top: 5px;
  }

  .mt-10{
    margin-top: 10px;
  }

  .gender-float{
    text-align: right;
  }

  .upload-file{
    width: 0;
    height: 0;
  }

  .upload-file-label{
    display: block;
    color: white;
    padding: 10px;
    text-align: center;
    border-radius: 6px;
  }

  .elipsis{
    text-overflow: ellipsis;
    overflow: hidden;
    width: auto;
    height: 1.2em;
    white-space: nowrap;
  }

  .text-none{
    text-transform: none;
    font-size: 14px;
  }
  .button{
    width: 30% !important;
    float: right;
    background: $primary-color !important;
    color: white;
    border-radius: 5px;
  }
  .button-back{
    width: 100px !important;
    background: white !important;
    color: $secondary-color;
    border-radius: 5px;
  }
  .cloud-image{
    width:10%;
    height:10%;
  }
  .upload-file-label {
  display: block;
  color: white;
  padding: 10px;
  text-align: center;
  border-radius: 6px;
  margin-top: 5px;
  margin-left: 35%;
  margin-right: 35%;
}
  @media screen and (max-width: 991px) {
    .mt-5{
      margin-top: 0;
    }

    .gender-float{
      text-align: left;
    }

    .mb-0{
      margin-bottom: 0;
    }

    .button {
      float:left;
      width: 100% !important;
    }
    .button-back {
      margin-bottom: 2px;
      float:left;
      width: 100% !important;
    }
  }

  @media screen and (max-width: 365px) {
    >>> .el-radio-button--small .el-radio-button__inner {
      padding: 9px 7px;
    }
     .button {
      float:left;
      width: 100% !important;
    }
    .button-back {
      margin-bottom: 2px;
      float:left;
      width: 100% !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Account/Dashboard/InsuranceRegistration.vue